import styled from 'styled-components'

import Background from '../Background'

const Description = styled(Background).attrs({
  type: 'white',
})`
  width: 100%;
  padding: ${props => props.theme.gutter * 2}px;

  p {
    margin: 0;
  }

  p + p {
    margin-top: 1.45rem;
  }
`

export default Description
